import { styled } from 'linaria/react';
import { COLORS, FONTS } from '../../../styles/constants';

export const StyledPrivate = styled.span<{ isDark: boolean }>`
  backdrop-filter: blur(2px);
  border-radius: 999px;
  color: ${COLORS.brown.dark[100]};
  font: 14px/140% ${FONTS.secondary};
  padding: 4px 8px;
  width: fit-content;
  background: linear-gradient(270deg, rgba(13, 127, 175, 0.3) 0%, rgba(190, 123, 74, 0.3) 100%),
    rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(2px);
`;
